import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseRefetchQuery = (wrapperOptions) => {
    const useRefetchQuery = () => {
        const client = useQueryClient();
        return () => {
            const queryKey = getQueryBaseKey(wrapperOptions, 'query');
            return client.refetchQueries({ queryKey });
        };
    };
    return useRefetchQuery;
};
